// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputPhone-module_flagIconDropdown__oKO0P {
    display: flex;
    padding-right: 8px;
    margin-right: 16px;
    border-right: 1px solid var(--input-phone-divider);
    cursor: pointer;
}

.inputPhone-module_isDisabled__YZp1a {
    cursor: default;
}

.inputPhone-module_iconContainer__J9EPx {
    margin-left: 4px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Inputs/inputPhone.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,kDAAkD;IAClD,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".flagIconDropdown {\n    display: flex;\n    padding-right: 8px;\n    margin-right: 16px;\n    border-right: 1px solid var(--input-phone-divider);\n    cursor: pointer;\n}\n\n.isDisabled {\n    cursor: default;\n}\n\n.iconContainer {\n    margin-left: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flagIconDropdown": `inputPhone-module_flagIconDropdown__oKO0P`,
	"isDisabled": `inputPhone-module_isDisabled__YZp1a`,
	"iconContainer": `inputPhone-module_iconContainer__J9EPx`
};
export default ___CSS_LOADER_EXPORT___;
